import { Box, Link, Typography } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";

function NeedHelp({ docUrl }: { docUrl: string }) {
  return (
    <Box display={"flex"} justifyContent={"right"} mb={2} mt={1}>
      {" "}
      <Link
        href={docUrl}
        target="_blank"
        underline="none"
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.5,
          px: 1.2,
          py: 0.5,
          borderRadius: "20px",
          backgroundColor: "#f5f5f5",
          transition: "background-color 0.2s ease, box-shadow 0.2s ease",
          "&:hover": {
            backgroundColor: "#e0e0e0",
            boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
            textDecoration: "none",
          },
        }}
      >
        <InfoIcon fontSize="small" color="primary"/>
        <Typography variant="body2" fontWeight={500} color={"primary"}>
          Need Help?
        </Typography>
      </Link>
    </Box>
  );
}

export default NeedHelp;
